import { Box, IconButton, Stack, useTheme } from "@mui/material";
import { TemplateData, useDeleteTemplate } from "./templates";
import { useTemplateContext } from "./TemplateContext";
import { useEffect, useMemo } from "react";
import { useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { DeleteIcon } from "../../icons";
import { useTemplatesMemo } from "./useTemplatesMemo";

type TemplateThumbnailViewProps = {};
export const TemplateThumbnailView = ({}: TemplateThumbnailViewProps) => {
  const { changeTemplate, state, changeCategory, changeClientType, apiTemplates } = useTemplateContext();
  const { mutate: deleteTemplate } = useDeleteTemplate();
  const queryClient = useQueryClient();
  const templates = useTemplatesMemo();
  useEffect(() => {
    changeCategory();
    changeTemplate(templates?.at(0));
  }, [state.isClientType]);

  useEffect(() => {
    if (state.template) return;
    if (typeof apiTemplates === "undefined") return;
    if (!state.isAdmin) {
      var useClientType = apiTemplates!.savedTemplates.length > 0;
      changeClientType(useClientType);
    }
    changeTemplate(templates?.at(0));
  }, [apiTemplates]);

  const handleDelete = (item: TemplateData) => {
    deleteTemplate(item.id, {
      onSuccess: () => {
        toast.success("Template deleted successfully.");
        queryClient.invalidateQueries("templates");
      },
    });
  };
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        zIndex: 99,
        width: "170px",
        left: 0,
        bottom: 0,
        scrollbarWidth: "none",
        overflow: "scroll",
      }}
    >
      <Stack spacing={2} sx={{}}>
        {templates?.map((item, i) => (
          <TemplateThumbnail
            selected={item.id === state.template?.id}
            key={item.id}
            isClient={item.isClient}
            id={item.id}
            imageUrl={item.imageUrl}
            onClick={() => changeTemplate(item)}
            onDeleteClick={() => {
              handleDelete(item);
            }}
          />
        ))}
      </Stack>
    </Box>
  );
};

type TemplateThumbnailProps = {
  id: number;
  imageUrl: string;
  onClick?: () => void;
  onDeleteClick?: () => void;
  isClient: boolean;
  selected?: boolean;
};
export const TemplateThumbnail = ({ id, imageUrl, onClick, onDeleteClick, isClient, selected = false }: TemplateThumbnailProps) => {
  return (
    <Box
      sx={{
        position: "relative",
        "& button.MuiIconButton-root": {
          position: "absolute",
          display: "none",
          right: "0",
          top: 0,
        },
        "&:hover button.MuiIconButton-root": {
          display: "block ",
        },
      }}
    >
      <Box
        id={`image-${id}`}
        component={"img"}
        src={imageUrl}
        sx={{
          width: "100%",
          cursor: "pointer",
          maxHeight: "220px",
          borderRadius: "0.625rem",
          objectFit: "cover",
          objectPosition: "0px 0px",
          ...(selected && { border: `4px solid red` }),
        }}
        onClick={onClick}
      />
      {isClient && (
        <IconButton color="error" onClick={onDeleteClick}>
          <DeleteIcon />
        </IconButton>
      )}
    </Box>
  );
};
